'use strict';

function LoanDetailPayments() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_ComponentDataBind, _Routes];
  this.declaredClass = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
    this.$node = $(this.node);
    var selectedProduct = this._routes[location.pathname].primaryState; // TEMP HARDCODE
    this.$node.addClass('is-' + selectedProduct);
    this.onDataBindUpdate('loanPaymentDate', this.displayDate.bind(this));
  };

  this.displayDate = function () {
    this.$node.find('.js--loan-payment-date').text(moment(this.loanPaymentDate).format('MMM D'));
  };

  this.destroy = function () {};
}